<template>
	<v-row
		v-if="types.length > 0"
		class="justify-center align-center"
	>
		<v-col
			v-for="type in types"
			:key="type.id"
			cols="12"
			sm="3"
		>
			<v-img
				max-width="180"
				max-height="220"
				:alt="type.name"
				:src="type.logo"
				hover
			/>
		</v-col>
	</v-row>
</template>

<script>
import { types } from "src/store/modules/Type.module";
import GameType from "./GameType.vue";

export default {
	name: "GamesType",
	components: { GameType },
	data () {
		return {
			overlay: false,
		};
	},
	computed: {
		types () {
			return this.$store.state.TypeModule.types.filter((type) => type.active);
		},
	},
	created () {
		this.$store.dispatch(types.FETCH);
	},
	methods: {
		beforeRouter (type) {
			this.$store.commit(types.GET, type);
		},
		chooseType (type) {
			this.$emit("choseType", type);
		},
	},
};
</script>

<style scoped>
.game-type-image{
  cursor: pointer;
  max-width: 250px;
  max-height: 250px;
}
</style>
